import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Cookie from 'js-cookie';

import { gtmPushUserLogin } from 'client/utils/tracking';
import { getLoginUserInfo } from 'client/utils/login';
import { setCurrentLoginID } from 'client/redux/modules/userLoginState';
import useClientErrorHandler from 'client/hooks/useClientErrorHandler';
import { loginTypeMappingPointRoutesParam } from 'config/loginTypes';

export function usePushLoginEvent() {
    const dispatch = useDispatch();
    const errHandler = useClientErrorHandler();
    const loginMethod = useSelector(s => s.settingPromo.loginMethod);
    const isLogin = useSelector(s => s.userLoginState.isLogin);
    const [loginType] = loginTypeMappingPointRoutesParam[loginMethod] || [null];

    const currentEntryUUID = useSelector(s => s.userEntryState.currentEntryUUID);
    const promoId = useSelector(s => s.promo.id);

    useEffect(() => {
        if (isLogin && currentEntryUUID && Boolean(loginMethod) && Cookie.get('gtm_login_event')) {
            try {
                async function getLoginInfo() {
                    const loginUserInfo = await getLoginUserInfo(loginMethod);
                    const loginId = loginUserInfo?.id;
                    const loginType = loginUserInfo?.loginType;

                    dispatch(setCurrentLoginID(loginId));
                    gtmPushUserLogin({ uid: loginId, loginType, promoId });
                    Cookie.remove('gtm_login_event');
                }
                getLoginInfo();
            } catch (err) {
                errHandler({ err });
            }
        }
    }, [currentEntryUUID, dispatch, errHandler, isLogin, loginMethod, loginType, promoId]);
}
